import React, { Fragment } from 'react';
import { LinkButton, Message, Text, Icon } from '@innovaccer/design-system';

import './styles.module.css';

function ErrorPoints(props) {
  return (
    <div data-testid="error-point" className="d-flex align-items-center">
      <Icon size={6} name="circle" appearance="alert" />
      <Text color="alert" className="ml-4 my-3">
        {props.message}
      </Text>
    </div>
  );
}

function ShowError(props) {
  const [showMore, setShowMore] = React.useState(false);
  return (
    <div className="p-3">
      <Message appearance="alert" className="m-6 StandardETLErrorMessage">
        {Array.isArray(props.message) ? (
          <Fragment>
            {showMore
              ? props.message.map((item) => <ErrorPoints message={item} />)
              : props.message.slice(0, 2).map((item) => <ErrorPoints message={item} />)}
          </Fragment>
        ) : (
          <Text color="alert">
            {showMore ? props.message : props.message.substr(0, 200)}
            {props.message.length > 200 && '...'}
          </Text>
        )}
        {(Array.isArray(props.message) ? props.message.length > 2 : props.message.length > 200) && (
          <LinkButton className="mt-4" size="tiny" aria-label="regular" onClick={() => setShowMore(!showMore)}>
            {showMore ? 'Hide' : 'Show more'}
          </LinkButton>
        )}
      </Message>
    </div>
  );
}

export default ShowError;
